import { Component, Input, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkerProfileAccessService } from 'src/app/data/worker-profile-access.service';

@Component({
  selector: 'app-worker-profile-supervisors',
  templateUrl: './worker-profile-supervisors.component.html',
  styleUrls: ['./worker-profile-supervisors.component.scss'],
  standalone: false
})
export class WorkerProfileSupervisorsComponent implements OnInit {
  private workerProfileAccessService = inject(WorkerProfileAccessService);

  @Input() workerId: number;
  isLoggedUserProfile$: Observable<boolean>;


  constructor() {
  }

  ngOnInit(): void {
    this.isLoggedUserProfile$ = this.workerProfileAccessService.isLoggedUserProfile$;
  }
}
